<div [formGroup]="mailingAddressForm">
  <div fxFlex>
    @for (address of mailingAddresses; track address) {
      <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap>
        @if (!isDeleted(address)) {
          <mailing-address formArrayName="rows" [mailingAddress]="address" [viewOnly]="viewOnly" [usages]="getAddressUsages(address)" [refresh]="refresh" (edit)="onEdit(address)" (primaryChanged)="onPrimaryChanged(address)" (forwardingChanged)="onForwardingChanged(address)" (certify)="onCertify(address)" (delete)="onDelete(address)">
          </mailing-address>
        }
      </div>
    }
  </div>

  @if (invalid) {
    <div fxLayoutAlign="center start" class="error">
      <div>The Mailing Address(es) could not be saved:</div>
      <ul>
        @if (hasAtLeastOneError) {
          <li>
            There must be at least one Mailing Address
          </li>
        }
        @if (hasNoPrimaryError) {
          <li>
            Please Select a Primary Mailing Address
          </li>
        }
      </ul>
    </div>
  }
</div>
